var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDesire(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 473,
    zoomAndPan: "magnify",
    viewBox: "0 0 354.75 354.749994",
    height: 473,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a95077e340"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 20 L 354.5 20 L 354.5 335 L 0 335 Z M 0 20 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a95077e340)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c2892c",
    d: "M 325.332031 50.28125 C 306.34375 31.292969 281.054688 20.789062 254.1875 20.789062 C 227.320312 20.789062 201.953125 31.292969 182.964844 50.355469 L 177.488281 55.835938 L 171.859375 50.207031 C 152.796875 31.144531 127.507812 20.636719 100.5625 20.636719 C 73.695312 20.636719 48.480469 31.070312 29.492188 50.132812 C 10.429688 69.195312 0 94.484375 0 121.351562 C 0 148.21875 10.507812 173.511719 29.570312 192.496094 L 166.679688 329.609375 C 169.53125 332.460938 173.433594 334.113281 177.5625 334.113281 C 181.613281 334.113281 185.519531 332.460938 188.445312 329.609375 L 325.179688 192.722656 C 344.242188 173.660156 354.675781 148.367188 354.75 121.503906 C 354.824219 94.636719 344.316406 69.34375 325.332031 50.28125 Z M 99.4375 87.957031 C 81.5 87.957031 66.867188 102.589844 66.867188 120.527344 C 66.867188 128.78125 60.1875 135.460938 51.933594 135.460938 C 43.675781 135.460938 37 128.78125 37 120.527344 C 37 86.15625 64.992188 58.160156 99.363281 58.160156 C 107.617188 58.160156 114.296875 64.839844 114.296875 73.097656 C 114.371094 81.351562 107.691406 87.957031 99.4375 87.957031 Z M 99.4375 87.957031 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesire);
export default __webpack_public_path__ + "static/media/desire.19277cdfe8866e575c8d566a35025e0b.svg";
export { ForwardRef as ReactComponent };